import React, { useState } from 'react';

const styles = {
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '20px',
  },
  groupLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1f2937',
    marginBottom: '4px',
  },
  entryRow: {
    display: 'grid',
    gridTemplateColumns: '220px 1fr auto auto',
    alignItems: 'center',
    gap: '10px',
    padding: '10px',
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
  },
  titleInput: {
    height: '38px',
    padding: '0 12px',
    fontSize: '14px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    outline: 'none',
    color: '#111827',
    background: '#fff',
  },
  fileInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '38px',
  },
  fileInput: {
    fontSize: '13px',
    color: '#374151',
    width: '100%',
  },
  fileNameBadge: {
    fontSize: '12px',
    color: '#374151',
    background: '#eef2ff',
    border: '1px solid #c7d2fe',
    borderRadius: '6px',
    padding: '4px 8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '140px',
  },
  removeBtn: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    border: 'none',
    background: '#fee2e2',
    color: '#dc2626',
    fontSize: '16px',
    fontWeight: 700,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
  addBtn: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    border: 'none',
    background: '#dcfce7',
    color: '#16a34a',
    fontSize: '18px',
    fontWeight: 700,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
  placeholderBtn: {
    width: '30px',
    height: '30px',
  },
  previewWrapper: {
    gridColumn: '1 / -1',
    marginTop: '4px',
  },
  previewImage: {
    position: 'relative',
    display: 'inline-block',
  },
  previewImg: {
    width: '90px',
    height: '90px',
    objectFit: 'cover',
    borderRadius: '6px',
    border: '1px solid #e5e7eb',
  },
};

function FileEntryUploader() {
  const [fileEntries, setFileEntries] = useState([
    { id: Date.now(), title: '', file: null, preview: null },
  ]);

  const updateTitle = (id, title) => {
    setFileEntries((prev) =>
      prev.map((e) => (e.id === id ? { ...e, title } : e))
    );
  };

  const updateFile = (id, file) => {
    if (!file) return;
    const isImage = file.type.startsWith('image/');

    if (isImage) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileEntries((prev) =>
          prev.map((entry) =>
            entry.id === id
              ? { ...entry, file, preview: e.target.result }
              : entry
          )
        );
      };
      reader.readAsDataURL(file);
    } else {
      setFileEntries((prev) =>
        prev.map((entry) =>
          entry.id === id ? { ...entry, file, preview: null } : entry
        )
      );
    }
  };

  const addEntry = () => {
    setFileEntries((prev) => [
      ...prev,
      { id: Date.now(), title: '', file: null, preview: null },
    ]);
  };

  const removeEntry = (id) => {
    setFileEntries((prev) => prev.filter((e) => e.id !== id));
  };

  return (
    <div style={styles.formGroup}>
      <label style={styles.groupLabel}>Upload sample images / PDFs</label>

      {fileEntries.map((entry, index) => {
        const isLast = index === fileEntries.length - 1;

        return (
          <div key={entry.id}>
            <div style={styles.entryRow}>
              <input
                type="text"
                placeholder="Title"
                value={entry.title}
                onChange={(e) => updateTitle(entry.id, e.target.value)}
                style={styles.titleInput}
              />

              <div style={styles.fileInputWrapper}>
                <input
                  type="file"
                  accept="image/*,.pdf"
                  onChange={(e) => updateFile(entry.id, e.target.files[0])}
                  style={styles.fileInput}
                />
              </div>

              {entry.file && !entry.preview && (
                <span style={styles.fileNameBadge} title={entry.file.name}>
                  {entry.file.name}
                </span>
              )}

              {fileEntries.length > 1 ? (
                <button
                  type="button"
                  style={styles.removeBtn}
                  onClick={() => removeEntry(entry.id)}
                  aria-label="Remove entry"
                >
                  ×
                </button>
              ) : (
                <div style={styles.placeholderBtn} />
              )}

              {isLast ? (
                <button
                  type="button"
                  style={styles.addBtn}
                  onClick={addEntry}
                  aria-label="Add entry"
                >
                  +
                </button>
              ) : (
                <div style={styles.placeholderBtn} />
              )}
            </div>

            {entry.preview && (
              <div style={styles.previewWrapper}>
                <div style={styles.previewImage}>
                  <img
                    src={entry.preview}
                    alt={entry.title || 'Sample preview'}
                    style={styles.previewImg}
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default FileEntryUploader;